export default [
  {
    url: "/back",
    name: "분야 바로가기",
    icon: "ArrowLeftIcon",
    activeCode: "",
  },
  {
    url: "/home",
    name: "대시보드",
    icon: "",
    activeCode: "",
  },
  {
    url: "/",
    name: "중대시민재해 현황",
    icon: "",
    activeCode: "",
    submenu: [
      // 은평
      {
        url: "/field/facility",
        name: "시설물",
        icon: "w-line",
        activeCode: "field-facility",
      },
      // 공중교통수단
      {
        url: "/field/public-transportation",
        name: "공중교통수단",
        icon: "w-line",
        activeCode: "field-public-transportation",
      },
      // 은평
      {
        url: "/field/workplace-material/info",
        name: "원료·제조물 사업장",
        icon: "w-line",
        activeCode: "field-workplace-material",
      },
      // 공중(다중)이용시설
      {
        url: "/field/facility-public",
        name: "공중(다중)이용시설",
        icon: "w-line",
        activeCode: "field-facility-public",
      },
    ],
  },
  // {
  //   url: "/",
  //   name: "안전·보건 경영방침",
  //   icon: "",
  //   activeCode: "",
  //   submenu: [
  //     {
  //       url: "/tab/101",
  //       name: "안전·보건 경영방침",
  //       icon: "w-line",
  //       groupName: ["101"],
  //     },
  //     {
  //       url: "/tab/109",
  //       name: "사업장 안전·보건 경영방침",
  //       icon: "w-line",
  //       groupName: ["109"],
  //     },
  //   ],
  // },
  {
    url: "/",
    name: "안전·보건조직체계",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/126",
        name: "안전보건조직 체계도",
        icon: "w-line",
        activeCode: "",
        groupName: ["126"],
      },
      {
        url: "/tab/282",
        name: "안전보건관리책임자 선임",
        icon: "w-line",
        activeCode: "",
        groupName: ["282"],
      },
      {
        url: "/tab/297",
        name: "관리감독자 선임",
        icon: "w-line",
        activeCode: "",
        groupName: ["297"],
      },
      {
        url: "/tab/461",
        name: "안전보건 인력 현황",
        icon: "w-line",
        activeCode: "",
        groupName: ["461"],
      },
      {
        url: "/tab/358",
        name: "종사자 정보",
        icon: "w-line",
        activeCode: "",
        groupName: ["358"],
      },
      {
        url: "/tab/319",
        name: "안전보건관리체계 구축 계획 승인(중대시민재해)",
        icon: "w-line",
        activeCode: "",
        groupName: ["319"],
      },
      {
        url: "/tab/436",
        name: "유관기관 비상연락망",
        icon: "w-line",
        activeCode: "",
        groupName: ["436"],
      },
      // {
      //   url: "/tab/140",
      //   name: "안전·보건관리체계 구축 현황(중대산업재해)",
      //   icon: "w-line",
      //   activeCode: "",
      //   groupName: ["140"],
      // },
    ],
  },
  {
    url: "/",
    name: "안전·보건관리 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/101",
        name: "안전·보건 경영방침",
        icon: "w-line",
        groupName: ["101"],
      },
      {
        url: "/tab/109",
        name: "사업장 안전·보건 경영방침",
        icon: "w-line",
        groupName: ["109"],
      },
      {
        url: "/tab/398",
        name: "안전보건 일정표",
        icon: "w-line",
        activeCode: "",
        groupName: ["398"],
      },
      {
        url: "/tab/137",
        name: "안전·보건 점검 계획",
        icon: "w-line",
        activeCode: "",
        groupName: ["137"],
      },
      {
        url: "/tab/134",
        name: "반기별 보고",
        icon: "w-line",
        activeCode: "",
        groupName: ["134"],
      },
      {
        url: "/tab/286",
        name: "안전보건관리책임자 업무수행평가표",
        icon: "w-line",
        activeCode: "",
        groupName: ["286"],
      },
      {
        url: "/tab/287",
        name: "관리감독자 업무수행평가표",
        icon: "w-line",
        activeCode: "",
        groupName: ["287"],
      },
      {
        url: "/tab/130",
        name: "수급업체 수행평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["130"],
      },
      {
        url: "/tab/129",
        name: "종사자 참여 평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["129"],
      },
      // {
      //   url: "/tab/152",
      //   name: "산업안전보건위원회",
      //   icon: "w-line",
      //   activeCode: "",
      //   groupName: ["152"],
      // },
      {
        url: "/tab/153",
        name: "노사협의체",
        icon: "w-line",
        activeCode: "",
        groupName: ["153"],
      },
    ],
  },
  // 은평
  {
    url: "/",
    name: "안전·보건 확보 의무",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/348",
        name: "(시설물)안전·보건 확보 의무",
        icon: "w-line",
        activeCode: "",
        groupName: ["348"],
      },
      {
        url: "/tab/480",
        name: "(공중교통수단)안전·보건 확보 의무",
        icon: "w-line",
        activeCode: "",
        groupName: ["480"],
      },
      {
        url: "/tab/349",
        name: "(원료·제조물)안전·보건 확보 의무",
        icon: "w-line",
        activeCode: "",
        groupName: ["349"],
      },
      {
        url: "/tab/481",
        name: "(공중(다중)이용시설)안전·보건 확보 의무",
        icon: "w-line",
        activeCode: "",
        groupName: ["481"],
      },
    ],
  },
  // 은평
  {
    url: "/",
    name: "안전·보건 예산",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/155",
        name: "(시설물)안전보건 예산",
        icon: "w-line",
        activeCode: "",
        groupName: ["155"],
      },
      {
        url: "/tab/478",
        name: "(공중교통수단)안전보건 예산",
        icon: "w-line",
        activeCode: "",
        groupName: ["478"],
      },
      {
        url: "/tab/409",
        name: "(원료·제조물)안전보건 예산",
        icon: "w-line",
        activeCode: "",
        groupName: ["409"],
      },
      {
        url: "/tab/479",
        name: "(공중(다중)이용시설)안전보건 예산",
        icon: "w-line",
        activeCode: "",
        groupName: ["479"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 교육",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/107",
        name: "안전·보건 교육",
        icon: "w-line",
        activeCode: "",
        groupName: ["107"],
      },
      {
        url: "/tab/132/page",
        name: "교육 모니터링",
        icon: "w-line",
        activeCode: "",
        groupName: ["132"],
      },
      // 은평
      {
        url: "/tab/356",
        name: "법정의무교육 이수 현황",
        icon: "w-line",
        activeCode: "",
        groupName: ["356"],
      },
    ],
  },
  // {
  //   url: "/",
  //   name: "종사자의견청취",
  //   icon: "",
  //   activeCode: "",
  //   submenu: [
  //     // 강서
  //     {
  //       url: "/tab/473",
  //       name: "종사자 설문조사",
  //       icon: "w-line",
  //       activeCode: "",
  //       groupName: ["473"],
  //     },
  //   ],
  // },
  {
    url: "/",
    name: "위험성평가",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/161",
        name: "정기 위험성평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["161"],
      },
      {
        url: "/tab/162",
        name: "수시 위험성평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["162"],
      },
    ],
  },
  {
    url: "/",
    name: "유해·위험요인 관리",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/",
        name: "유해·위험요인 조사표",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/tab/554",
            name: "유해·위험방지 기계 기구",
            icon: "w-line",
            activeCode: "",
            groupName: ["554"],
          },
          {
            url: "/tab/305",
            name: "안전검사 대상 기계 기구",
            icon: "w-line",
            activeCode: "",
            groupName: ["305"],
          },
          {
            url: "/tab/160",
            name: "유해·위험요인 점검(개선)사항 요청",
            icon: "w-line",
            activeCode: "",
            groupName: ["160"],
          },
        ],
      },
      // 은평
      {
        url: "/",
        name: "유해·위험요인 점검표",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/tab/352",
            name: "유해·위험요인 점검표",
            icon: "w-line",
            activeCode: "",
            groupName: ["352", "353", "354"],
          },
        ],
      },
      {
        url: "/tab/160",
        name: "유해·위험요인 점검(개선)사항 요청",
        icon: "w-line",
        activeCode: "",
        groupName: ["160"],
      },
      {
        url: "/tab/372",
        name: "아차사고 등록",
        icon: "w-line",
        activeCode: "",
        groupName: ["372"],
      },
    ],
  },
  {
    url: "/",
    name: "주요 시설물 관리",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/114",
        name: "점검",
        icon: "w-line",
        activeCode: "",
        groupName: ["114"],
      },
      {
        url: "/tab/234",
        name: "진단",
        icon: "w-line",
        activeCode: "",
        groupName: ["234"],
      },
      {
        url: "/tab/235",
        name: "보수",
        icon: "w-line",
        activeCode: "",
        groupName: ["235"],
      },
      {
        url: "/tab/236",
        name: "보강",
        icon: "w-line",
        activeCode: "",
        groupName: ["236"],
      },
      {
        url: "/tab/237",
        name: "교체",
        icon: "w-line",
        activeCode: "",
        groupName: ["237"],
      },
    ],
  },
  {
    url: '/',
    name: '안전·보건 점검',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: "/tab/100",
        name: "작업장 합동점검",
        icon: "w-line",
        activeCode: "",
        groupName: ["100"],
      },
      {
        url: "/tab/438",
        name: "휴게시설 주요 체크리스트",
        icon: "w-line",
        activeCode: "",
        groupName: ["438"],
      },
      {
        url: "/tab/561",
        name: "온열·한랭질환 안전점검표",
        icon: "w-line",
        activeCode: "",
        groupName: ["561"],
      },
    ]
  },
  {
    url: "/",
    name: "중대시민재해 발생 대비 대책",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/116/page",
        name: "중대시민재해 발생 시 보고 절차 안내",
        icon: "w-line",
        activeCode: "",
        groupName: ["116"],
      },
      // 강서
      {
        name: "비상조치 및 처리 절차 안내",
        icon: "w-line",
        submenu: [
          {
            url: "/filelibrary/454",
            name: "상황별 비상 대비 시나리오",
            activeCode: "filelibrary-454",
            icon: "w-line",
          },
          {
            url: "/filelibrary/455",
            name: "사고별·시간별 시나리오",
            activeCode: "filelibrary-455",
            icon: "w-line",
          },
        ],
      },
      {
        url: "/tab/239",
        name: "비상대피 훈련·교육·자체평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["239", "240", "241"],
      },
      {
        url: "/tab/242",
        name: "비상조치계획 수립",
        icon: "w-line",
        activeCode: "",
        groupName: ["242"],
      },
    ],
  },
  {
    url: "/",
    name: "재해발생보고",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/117",
        name: "산업재해조사표",
        icon: "w-line",
        activeCode: "",
        groupName: ["117"],
      },
      // 농협
      {
        url: "/tab/307",
        name: "안전사고 발생 보고서",
        icon: "w-line",
        activeCode: "",
        groupName: ["307"],
      },
      {
        url: '/tab/308',
        name: '재발방지 조치 보고서',
        icon: 'w-line',
        activeCode: '',
        groupName: ['308'],
      },
      {
        url: "/tab/244",
        name: "중대재해 발생 보고",
        icon: "w-line",
        activeCode: "",
        groupName: ["244"],
      },
      {
        url: "/tab/245",
        name: "재발방지계획서",
        icon: "w-line",
        activeCode: "",
        groupName: ["245"],
      },
      // 강서
      {
        url: "/tab/443",
        name: "재발방지 조치 보고서",
        icon: "w-line",
        activeCode: "",
        groupName: ["443"],
      },
    ],
  },
  {
    url: "/",
    name: "자료실",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/filelibrary/340",
        name: "자료실",
        activeCode: "filelibrary-340",
        icon: "w-line",
      },
    ],
  },
  {
    url: "/community",
    name: "커뮤니티",
    slug: "community",
    icon: "",
    submenu: [
      {
        url: "/community/businessnews",
        name: "기관장 메세지",
        activeCode: "community_businessnews",
        icon: "w-line",
        groupName: ['16'],
      },
      {
        url: "/community/healthinfo",
        name: "안전보건 주요 일정",
        activeCode: "community_healthinfo",
        icon: "w-line",
        groupName: ['18'],
      },
      {
        url: "/community/unitbusinessnews",
        name: "구성원 요청사항",
        activeCode: "community_unitbusinessnews",
        icon: "w-line",
        groupName: ['19'],
      },
      {
        url: "/community/qna",
        name: "Q&A",
        activeCode: "community_qna",
        icon: "w-line",
        groupName: ['17'],
      },
    ],
  },
  {
    url: "/mypage",
    name: "마이페이지",
    slug: "safety",
    icon: "",
    submenu: [
      {
        url: "/mypage/workstatus",
        name: "업무현황",
        slug: "",
        icon: "w-line",
        groupName: ['90'],
      },
      {
        url: "/mypage/alert",
        name: "알림",
        slug: "",
        icon: "w-line",
        groupName: ['91'],
      },
      {
        url: "/",
        name: "결재관리",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/approval-request",
            name: "결재요청함",
            slug: "",
            icon: "w-line",
            groupName: ['93'],
          },
          {
            url: "/approval-await",
            name: "결재대기함",
            slug: "",
            icon: "w-line",
            groupName: ['94'],
          },
          {
            url: "/approval-process",
            name: "결재진행함",
            slug: "",
            icon: "w-line",
            groupName: ['95'],
          },
          {
            url: "/approval-complete",
            name: "완료문서함",
            slug: "",
            icon: "w-line",
            groupName: ['96'],
          },
          {
            url: "/approval-reject",
            name: "반려문서함",
            slug: "",
            icon: "w-line",
            groupName: ['97'],
          },
          {
            url: "/approval-reference",
            name: "참조/회람문서함",
            slug: "",
            icon: "w-line",
            groupName: ['98'],
          },
        ],
      },
      {
        url: "/",
        name: "설정",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/mypage/info-update",
            name: "개인정보변경",
            slug: "",
            icon: "w-line",
            groupName: ['92'],
          },
        ],
      },
    ],
  },
];
